import { Component, Input } from "@angular/core";

@Component({
    selector: "app-to-cart-toast",
    templateUrl: "./add-to-cart-toast.component.html",
    standalone: false
})
@Input()
export class AddToCartToastComponent {
  toastHeader: string;
  constructor() {}
}
